// TeamPanelForm.jsx
import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
    Typography
} from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab"; // si no lo tienes, lo agrego

const TeamPanelForm = ({
    open,
    onClose,
    teamKey,
    initialData = { name: "", coach: "", players: [] },
    onSave
}) => {
    const [teamName, setTeamName] = useState("");
    const [coachName, setCoachName] = useState("");
    const [teamColor, setTeamColor] = useState("");
    const [players, setPlayers] = useState([]);
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        setTeamName(initialData.name || "");
        setCoachName(initialData.coach || "");
        setTeamColor(initialData.teamColor || "");
        const filled = [...(initialData.players || [])];
        //filled.push({ number: "", name: "" })

        //        while (filled.length < 12) filled.push({ number: "", name: "" });
        setPlayers(filled);
    }, [initialData]);

    const handlePlayerChange = (index, key, value) => {
        const newPlayers = [...players];
        newPlayers[index] = { ...newPlayers[index], [key]: value };

        setPlayers(newPlayers);
    };

    const handleSave = () => {
        const cleaned = players.filter(p => p.number && p.name);

        const numbers = cleaned.map(p => p.number);
        const duplicates = numbers.filter((n, i) => numbers.indexOf(n) !== i);

        if (duplicates.length > 0) {
            setErrorMsg(`Hay jugadores con números repetidos: ${[...new Set(duplicates)].join(", ")}`);
            return;
        }

        onSave({
            name: teamName,
            coach: coachName,
            players: cleaned,
            teamColor: teamColor
        });

        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Configurar {teamKey === "A" ? "Equipo A" : "Equipo B"}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Nombre del Equipo"
                    fullWidth
                    margin="dense"
                    value={teamName}
                    onChange={(e) => setTeamName(e.target.value)}
                />
                <TextField
                    label="Nombre del Coach"
                    fullWidth
                    margin="dense"
                    value={coachName}
                    onChange={(e) => setCoachName(e.target.value)}
                />
                <TextField
                    label="Color del equipo"
                    fullWidth
                    margin="dense"
                    type="color"
                    value={teamColor}
                    onChange={(e) => setTeamColor(e.target.value)}
                />

                <Typography variant="subtitle1" style={{ marginTop: 16 }}>
                    Jugadores
                </Typography>
                <Grid container spacing={2}>aaaa
                    {[...players, { number: "", name: "" }].map((player, i) => (
                        <Grid container item xs={12} spacing={1} key={i}>
                            <Grid item xs={4}>
                                <TextField
                                    label="#"
                                    value={player.number}
                                    onChange={(e) => handlePlayerChange(i, "number", e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label="Nombre"
                                    value={player.name}
                                    onChange={(e) => handlePlayerChange(i, "name", e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button color="primary" variant="contained" onClick={handleSave}>
                    Guardar
                </Button>
            </DialogActions>
            <Snackbar
                open={!!errorMsg}
                autoHideDuration={4000}
                onClose={() => setErrorMsg("")}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity="error" onClose={() => setErrorMsg("")}>
                    {errorMsg}
                </Alert>
            </Snackbar>
        </Dialog>
    );
};

export default TeamPanelForm;
